export const HOMIE_FREE_MESSAGES = 3;

export function homieMessagesRemaining(used: number): number {
  const count = Number.isFinite(used) ? Math.max(0, Math.floor(used)) : 0;
  return Math.max(0, HOMIE_FREE_MESSAGES - count);
}
